<template>
  <div class="table mb-0 pt-3 bg-white rounded">
    <div class="expiry-data d-flex justify-content-between flex-wrap px-3 align-items-center mb-3">
      <h3 class="font-weight-bold f-20 text-left mb-0 text-black">{{ $t('users.title') }}</h3>
      <b-button @click="openAddUserModal"
        class="export equipment d-flex justify-content-center align-items-center w-fit-content" variant="primary">
        <b-icon icon="plus" class="p-0" aria-hidden="true"></b-icon>
        <p class="mb-0 ml-2 text-white px-0">{{ $t('users.addUser') }}</p>
      </b-button>
    </div>
    <!-- <form class="equipment-border mt-4 d-flex flex-wrap flex-sm-nowrap">
      <b-form-group label="Name" class="text-left label w-100 mr-3">
        <b-form-input type="text" class="input" required v-model="filterFields.name" @keydown.enter="getTeamMemberData()"
          @blur="getTeamMemberData()"></b-form-input>
      </b-form-group>

      <b-form-group label="Role" class="text-left select_arrow label w-100 mr-3">
        <b-form-select v-model="filterFields.role_choice" :options="options" @change="getTeamMemberData()" />
      </b-form-group>

      <b-form-group label="Email" class="text-left label w-100 mr-3">
        <b-form-input type="text" class="input" required v-model="filterFields.email" @keydown.enter="getTeamMemberData()"
          @blur="getTeamMemberData()"></b-form-input>
      </b-form-group>
      <b-form-group label="Status" class="text-left select_arrow label w-100 mr-3 mr-sm-0">
        <b-form-select class="input" required v-model="filterFields.app_user" :options="appUserOptions"
          @change="getTeamMemberData()"></b-form-select>
      </b-form-group>
    </form> -->
    <b-table :sticky-header="'calc(100vh - 273px)'" responsive :fields="translatedFields" :items="items" hover
      :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :no-local-sorting="true"
      :busy.sync="isBusy" :show-empty="emptyTable">
      <template #cell(name)="data">
        <!-- `data.value` is the value after formatted by the Formatter -->
        <div>
          <p class="mb-0">{{ data.value }}</p>
        </div>
      </template>
      <template #cell(tags)="data">
        <div v-if="data.value.length" class="d-flex align-items-center">
          <div class="table-tags mr-2">{{ data.value[0].add_tag }}</div>
          <v-app>
            <v-tooltip bottom v-if="data.value.length > 1">
              <template #activator="{ on, attrs }">
                <div class="table-tags" v-on="on" v-bind="attrs">+{{ data.value.length - 1 }}</div>
              </template> <span v-html="data.value.map((tag) => tag.add_tag).slice(1).join('<br>')"></span>
            </v-tooltip>
          </v-app>
        </div>
        <p class="mb-0" v-else>-</p>
      </template>
      <template #cell(app_user)="data">
        <b-button class="export table_btn d-flex justify-content-center align-items-center" :class="data.item.app_user === 'Active' ? 'equipment' : 'inactive-equipment'
          " :variant="data.item.app_user === 'Active' ? 'primary' : 'secondary'">
          <p class="mb-0">{{ data.value }}</p>
        </b-button>
      </template>
      <template #cell(role)="data">
        <p class="mb-0">{{ data.value.name }}</p>
      </template>
      <template #cell(action)="data">
        <div v-if="company[0].owner && company[0].owner.email !== data.item.email &&
          $store.state.user.user.team_member.user.username.split(
            `.${company[0].company_ID}`
          )[0] !== data.item.username
          ">
          <svg v-if="!data.item.last_login" class="mr-4 cursor-pointer" @click="userID = data.item.id; sendInviteUser = true" width="20" height="20" viewBox="0 0 20 20" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M3.07751 18.9975V15.5368H6.53822" stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round"></path>
            <path
              d="M18.8442 8.34855C19.7053 12.9277 16.9031 17.4673 12.328 18.6933C8.82635 19.6315 5.25353 18.3694 3.07751 15.7545"
              stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            <path
              d="M1.15502 11.6536C0.293936 7.07442 3.09617 2.53472 7.67127 1.30883C11.1727 0.370634 14.7452 1.63251 16.9213 4.24705"
              stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M16.9219 1V4.46071H13.4612" stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round"></path>
            <path
              d="M5.93818 10.4693C5.4485 10.3842 5.4485 9.6812 5.93818 9.59601C7.71219 9.28739 9.12316 7.93616 9.50822 6.17717L9.53773 6.04233C9.64368 5.55838 10.3328 5.55536 10.4429 6.03837L10.4788 6.1955C10.8781 7.94621 12.2894 9.28601 14.0585 9.59378C14.5506 9.67942 14.5506 10.3859 14.0585 10.4716C12.2894 10.7793 10.8781 12.1192 10.4788 13.8698L10.4429 14.027C10.3328 14.51 9.64368 14.507 9.53773 14.023L9.50822 13.8882C9.12316 12.1292 7.71219 10.778 5.93818 10.4693Z"
              stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
          <svg @click="updateUserData(data.item)" class="mr-4 cursor-pointer" width="18" height="18" viewBox="0 0 18 18"
            fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5.52719 16.7477L14.5274 7.74753L10.2525 3.4726L1.25226 12.4728C1.12836 12.5969 1.04034 12.7522 0.997548 12.9222L0 18L5.07684 17.0025C5.2473 16.9598 5.40322 16.8717 5.52719 16.7477V16.7477ZM17.4329 4.84205C17.796 4.47881 18 3.98622 18 3.4726C18 2.95898 17.796 2.46639 17.4329 2.10315L15.8968 0.567123C15.5336 0.203994 15.041 0 14.5274 0C14.0138 0 13.5212 0.203994 13.1579 0.567123L11.6219 2.10315L15.8968 6.37808L17.4329 4.84205Z"
              fill="#2CCE89" />
          </svg>
          <svg @click="userID = data.item.id; showMemberModal = true" class="cursor-pointer" width="19" height="20"
            viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 5.15704H17.6139" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              d="M3.0766 5.15704H15.537V17.6175C15.537 17.9846 15.3911 18.3368 15.1315 18.5964C14.8719 18.856 14.5197 19.0019 14.1525 19.0019H4.46109C4.0939 19.0019 3.74175 18.856 3.4821 18.5964C3.22247 18.3368 3.0766 17.9846 3.0766 17.6175V5.15704Z"
              stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M5.84607 5.15347V4.46123C5.84607 3.54325 6.21073 2.66287 6.85984 2.01377C7.50894 1.36466 8.38932 1 9.3073 1C10.2253 1 11.1057 1.36466 11.7548 2.01377C12.4039 2.66287 12.7685 3.54325 12.7685 4.46123V5.15347"
              stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M7.23175 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M11.385 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </div>
        <div v-else>-</div>
      </template>
    </b-table>
    <div class="entries-pagination px-0 px-sm-2">
      <div class="d-flex align-items-center flex-wrap">
        <div class="text-left show-entries mr-md-3 pl-3 pl-md-0 ml-md-0">
          <b-form-select v-model="perPage" :options="pageOptions" />
        </div>
        <div class="pagination">
          <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
            aria-controls="my-table"></b-pagination>
        </div>
        <p class="my-0 pr-3 pr-md-0 mr-md-1 mt-3 mt-sm-0">{{ positionText }}</p>
      </div>
    </div>
    <!-- Modal -->
    <b-modal id="modal-teammember" centered hide-footer no-close-on-backdrop no-close-on-esc>
      <template #modal-header="{ close }">
        <h5 class="modal-title">
          {{ editUserFlag ? $t('users.editUser') : $t('users.addUser') }}
        </h5>
        <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
          Close Modal
        </b-button>
      </template>
      <div class="d-block text-center">
        <b-row>
          <b-col lg="12" md="12" sm="12">
            <b-form-group :label="$t('users.emailLabel')" class="text-left label font-weight-normal">
              <b-form-input type="email" :placeholder="$t('users.emailPlaceholder')" class="unit" required :disabled="editUserFlag"
                v-model="newTeamMember.email"></b-form-input>
              <p v-if="errors && errors.email" class="field-error mb-lg-3">
                {{ errors.email[0] }}
              </p>
            </b-form-group>
            <b-col sm="12" class="mb-3 select_arrow text-left px-0">
              <label>{{ $t('users.roleLabel') }}</label>
              <b-form-select class="bg_white f-12" v-model="newTeamMember.role" :options="roleOptions"></b-form-select>
              <p v-if="errors && errors.role" class="field-error mb-lg-3">
                {{ errors.role[0] }}
              </p>
            </b-col>
          </b-col>
        </b-row>
        <div v-if="editUserFlag || userAddingStepper > 0">
          <b-row>
            <b-col lg="12" md="12" sm="12" class="text-left position-relative mb-2">
              <label class="state">{{ $t('users.tagsLabel') }}</label>
                <v-select multiple :options="allTags" class="f-12" :reduce="(option) => option.id"
                  v-model="newTeamMember.tags" />
                <p v-if="errors && errors.tags" class="field-error mb-lg-3">
                  {{ errors.tags[0] }}
                </p>
            </b-col>
            <b-col sm="12">
              <b-form-group :label="$t('users.firstNameLabel')" class="text-left label font-weight-normal">
                <b-form-input type="text" :placeholder="$t('users.firstNamePlaceholder')" class="unit" required
                  v-model="newTeamMember.first_name"></b-form-input>
                <p v-if="errors && errors.first_name" class="field-error mb-lg-3">
                  {{ errors.first_name[0] }}
                </p>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group :label="$t('users.lastNameLabel')" class="text-left label font-weight-normal">
                <b-form-input type="text" :placeholder="$t('users.lastNamePlaceholder')" class="unit" required
                  v-model="newTeamMember.last_name"></b-form-input>
                <p v-if="errors && errors.last_name" class="field-error mb-lg-3">
                  {{ errors.last_name[0] }}
                </p>
              </b-form-group>
            </b-col>

            <b-col lg="12" md="12" sm="12">
              <b-form-group :label="$t('users.phoneLabel')" class="text-left position-relative mb-2">
                <b-input-group size="lg" class="w-100" prepend="+1">
                  <b-form-input v-mask="phoneMask" v-model="newTeamMember.phone"></b-form-input>
                </b-input-group>
                <p v-if="errors && errors.phone" class="field-error mt-2">
                  {{ errors.phone[0] }}
                </p>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </div>
      <div class="d-flex align-items-center" :class="editUserFlag && company[0].owner && company[0].owner.email !== newTeamMember.email
        ? 'justify-content-between'
        : 'justify-content-end'
        ">
        <b-button class="mt-3 mr-3" variant="danger"
          v-if="editUserFlag && company[0].owner && company[0].owner.email !== newTeamMember.email"
          @click="showMemberModal = true">{{ $t('users.remove') }}</b-button>
        <div class="modal-footer border-0 p-0">
          <b-button class="mt-3 btn cancel m-0" block @click="$bvModal.hide('modal-teammember'); userAddingStepper = 0"
            :class="hasChanged || !editUserFlag ? 'mr-3' : ''">{{ editUserFlag ? $t('users.close') : $t('users.cancel') }}</b-button>
          <b-button class="mt-3 btn save m-0" variant="primary" v-if="editUserFlag && hasChanged"
            @click="updateTeamMemberData">{{ $t('users.save') }}</b-button>
          <b-button class="mt-3 btn save m-0" variant="primary" v-else-if="!editUserFlag"
            @click="onAddNewTeamMember">{{ $t('users.invite') }}</b-button>
        </div>
      </div>
    </b-modal>
    <DeleteModal v-if="showMemberModal" @confirm="deleteMemberItem($event)" :message="$t('users.removeConfirm')"
      :removeMessage="$t('users.removeLabel')" />
      <DeleteModal v-if="sendInviteUser" @confirm="sendInviteMember($event)" :message="$t('users.sendInviteConfirm')" :updateMessage="true" :removeMessage="''"/>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import DeleteModal from "@/components/DeleteModal.vue";
import { checkEmail, checkValueExists, checkPhoneFormat } from "../../services/helper";
export default {
  name: "Users",
  components: {
    vSelect,
    DeleteModal,
  },
  data() {
    return {
      states: [],
      countries: [],
      document: null,
      defaultData: {},
      roleOptions: [{
        value: null,
        text: ""
      }],
      editUserFlag: false,
      emptyTable: false,
      checkValueExists,
      sendInviteUser: false,
      checkEmail,
      checkPhoneFormat,
      fileName: null,
      showMemberModal: false,
      perPage: 50,
      currentPage: 1,
      userAddingStepper: 0,
      rows: 1,
      positionText: "",
      items: [],
      allTags: [],
      errors: {},
      teamDispatchGroups: [],
      sortBy: undefined,
      sortDesc: undefined,
      isBusy: false,
      statusOptions: [
        {
          value: "",
          text: "",
        },
        {
          value: "True",
          text: "Active",
        },
        {
          value: "False",
          text: "Inactive",
        },
      ],
      appUserOptions: [
        {
          value: "",
          text: "",
        },
        {
          value: "True",
          text: "Active",
        },
        {
          value: "False",
          text: "Inactive",
        },
      ],
      selected: null,
      pageOptions: [
        {
          value: 10,
          text: "10",
        },
        {
          value: 25,
          text: "25",
        },
        {
          value: 50,
          text: "50",
        },
        {
          value: 100,
          text: "100",
        },
      ],
      newTeamMember: {
        first_name: "",
        last_name: "",
        role: null,
        email: "",
        phone: "",
        tags: [],
        password: "",
        inviteNewMember: false,
        is_active: false,
      },
    };
  },

  computed: {
    ...mapGetters([
      "allTeamMembers",
      "dispatchGroups",
      "licenseInventory",
      "company",
      "currentTeamMember",
      "userCompany",
      "tags"
    ]),
    translatedFields() {
      return [
        { label: this.$t('users.nameColumn'), key: "name", sortable: true, tdClass: "align-middle", stickyColumn: true, thClass: 'font-table-weight-bold' },
        { key: "role", label: this.$t('users.roleColumn'), sortable: true, tdClass: "align-middle", thClass: 'font-table-weight-bold' },
        { key: "tags", label: this.$t('users.tagsColumn'), sortable: true, thClass: 'font-table-weight-bold' },
        { label: this.$t('users.emailColumn'), key: "email", sortable: true, tdClass: "align-middle", thClass: 'font-table-weight-bold' },
        { key: "phone", label: this.$t('users.phoneColumn'), sortable: true, tdClass: "align-middle", thClass: 'font-table-weight-bold' },
        { key: "Action", sortable: true, tdClass: "align-middle", thClass: 'font-table-weight-bold' },
      ];
    },
    phoneMask() {
      return this.newTeamMember?.phone?.length > 0
        ? [
          /\d/, /\d/, /\d/, " ",
          /\d/, /\d/, /\d/, " ",
          /\d/, /\d/, /\d/, /\d/
        ]
        : false; // Allows empty input
    },
    hasChanged() {
      return Object.keys(this.newTeamMember).filter(field => {
        return this.checkValueExists(this.newTeamMember[field]) != this.checkValueExists(this.defaultData[field])
      }).length > 0
    }
  },
  methods: {
    ...mapActions([
      "getAllTeamMembers",
      "addTeamMember",
      "sendInvite",
      "setNotification",
      "getDispatchGroups",
      "deleteTeamMember",
      "getTeamMember",
      "updateTeamMember",
      "setPassword",
      "checkUserExists",
      "setLoader",
      "getUserRoles",
      "getAllTags"
    ]),
    enforceLimit() {
      let cleaned = this.newTeamMember.phone.replace(/\D/g, ""); // Remove non-digits
      if (cleaned.length > 10) {
        this.newTeamMember.phone = this.newTeamMember.phone.slice(0, -1); // Remove last character
      }
    },
    async getRoles() {
      const data = await this.getUserRoles()
      data.map((role) => {
        this.roleOptions.push({
          value: role.id,
          text: role.name
        })
      })
    },
    async updateTeamMemberData() {
      const payload = {
        ...this.currentTeamMember,
        user: {
          first_name: this.newTeamMember.first_name,
          last_name: this.newTeamMember.last_name,
          email: this.newTeamMember.email,
          is_active: this.newTeamMember.is_active,
        },
        phone: this.newTeamMember.phone ? !this.newTeamMember.phone.includes("+1") ? "+1 " + this.newTeamMember.phone : this.newTeamMember.phone : '',
        roles: [this.newTeamMember.role],
        role: "User",
        state: this.currentTeamMember.state.id
          ? this.currentTeamMember.state.id
          : 54,
        license_state: this.currentTeamMember.license_state.id
          ? this.currentTeamMember.license_state.id
          : 54,
        tags: this.newTeamMember.tags
      };
      try {
        if (this.newTeamMember.password) {
          await this.setPassword({
            user: this.currentTeamMember.id,
            password: this.newTeamMember.password,
          });
        }
        if (this.newTeamMember.phone) {
          if (!this.checkPhoneFormat(this.newTeamMember.phone)) {
            throw {
              phone: [this.$t('users.wrongFormat')],
            };
          }
        }
        if (this.newTeamMember.email) {
          if (!this.checkEmail(this.newTeamMember.email)) {
            throw {
              email: [this.$t('users.wrongFormat')],
            };
          }
        }
        const nullKeys = this.checkNullValues({
          first_name: this.newTeamMember.first_name,
          last_name: this.newTeamMember.last_name,
          role: this.newTeamMember.role,
          email: this.newTeamMember.email
        });
        if (nullKeys.length === 0) {
          try {
            this.setLoader(true)
            await this.updateTeamMember({
              id: this.currentTeamMember.id,
              payload: { ...payload, phone: this.newTeamMember.phone ? !this.newTeamMember.phone.includes("+1") ? "+1 " + this.newTeamMember.phone : this.newTeamMember.phone : '' },
            });
            this.userAddingStepper = 0
            await this.setNotification({
              msg: this.$t('users.userUpdated', { name: `${this.newTeamMember.first_name} ${this.newTeamMember.last_name}` }),
              type: "success",
              color: "green",
            });
            await this.getTeamMemberData();
            this.setLoader(false)
            this.$bvModal.hide("modal-teammember");
          } catch (error) {
            this.setLoader(false)
            if (typeof error === "object") {
              this.errors = error;
              // eslint-disable-next-line no-ex-assign
            }
          }
        } else {
          let error = {};
          nullKeys.forEach((x) => {
            error[x] = [this.$t('users.fieldRequired')];
          });
          throw error;
        }
      } catch (error) {
        if (typeof error === "object") {
          this.errors = error;
          // eslint-disable-next-line no-ex-assign
        }
      }
    },
    sendInviteMember(status){
      if(status){
        this.sendInviteTeam(this.userID, "user-invite", true)
      }
      this.sendInviteUser = false;
    },
    deleteMemberItem(status) {
      if (status) {
        this.deleteMember(this.userID);
      }
      this.showMemberModal = false;
    },
    async deleteMember(id) {
      try {
        await this.deleteTeamMember(`${id}/?company_id=${this.userCompany}`);
        await this.setNotification({
          msg: this.$t('users.memberDeleted'),
          type: "success",
          color: "green",
        });
        this.$bvModal.hide("modal-teammember");
        await this.getTeamMemberData();
      } catch (error) {
        await this.setNotification({
          msg: error,
          type: "error",
          color: "red",
        });
      }
    },
    resetField() {
      this.$refs.docFile.value = null;
      this.fileName = null;
      this.document = null;
      this.errors = {
        document: null,
      };
    },
    async updateUserData(data) {
      this.$bvModal.show("modal-teammember");
      this.errors = {};
      this.editUserFlag = true;
      await this.getTeamMember({ id: data.id, fetch_user: true });
      this.userID = data.id
      this.newTeamMember.email = data.email;
      this.newTeamMember.role = data.role.id;
      this.newTeamMember.first_name = data.first_name;
      this.newTeamMember.last_name = data.last_name;
      this.newTeamMember.tags = data.tags.length ? data.tags.map((tag) => tag.id) : []
      this.newTeamMember.phone = this.currentTeamMember.phone
        ? this.currentTeamMember.phone !== "-"
          ? this.currentTeamMember.phone.startsWith("+1") ? this.currentTeamMember.phone.slice(2).trim() : this.currentTeamMember.phone
          : ""
        : "";
      this.newTeamMember.is_active = this.currentTeamMember.user.is_active;
      this.defaultData = JSON.parse(JSON.stringify(this.newTeamMember))
    },
    openAddUserModal() {
      this.editUserFlag = false;
      this.errors = {};
      (this.newTeamMember = {
        first_name: "",
        last_name: "",
        password: "",
        role: "",
        email: "",
        phone: "",
        inviteNewMember: false,
        is_active: false,
        tags: []
      }),
        this.$bvModal.show("modal-teammember");
    },
    checkNullValues(payload) {
      let nullKeys = [];
      for (let [key, value] of Object.entries(payload)) {
        if (!value) {
          nullKeys.push(key);
        }
      }
      return nullKeys;
    },
    async sendInviteTeam(id, type, showSuccess = false) {
      try {
        await this.sendInvite({
          user: id,
          invite_type: type
        });
        if(showSuccess){
          await this.setNotification({
            msg: this.$t('users.inviteSent'),
            type: "success",
            color: "green",
          });
        }
      } catch (error) {
        if (typeof error === "object") {
          this.errors = error;
          // eslint-disable-next-line no-ex-assign
          error = "Couldnot send email";
        }
        await this.setNotification({
          msg: error,
          type: "error",
          color: "red",
        });
      }
    },
    async onAddNewTeamMember() {
      if (this.userAddingStepper === 0) {
        try {
          const nullKeys = this.checkNullValues({
            role: this.newTeamMember.role,
            email: this.newTeamMember.email
          });
          if (nullKeys.length === 0) {
            if (!this.checkEmail(this.newTeamMember.email)) {
              throw {
                email: [this.$t('users.wrongFormat')],
              };
            }
            const { status } = await this.checkUserExists({ email: this.newTeamMember.email })
            if (status === 'User with this email already exists.' || status === 'Driver with this email already exists') {
              this.setLoader(true)
              const newMember = await this.addTeamMember({
                company_id: this.userCompany,
                user: {
                  email: this.newTeamMember.email
                },
                ...{
                  roles: [this.newTeamMember.role],
                  role: "User",
                  tags: this.newTeamMember.tags,
                }
              });
              await this.getTeamMemberData();
              await this.sendInviteTeam(newMember.id, "company-invite");
              await this.setNotification({
                msg: this.$t('users.userAdded', { name: `${newMember.user.first_name} ${newMember.user.last_name}` }),
                type: "success",
                color: "green",
              });
              this.userAddingStepper = 0
              this.setLoader(false)
              this.$bvModal.hide("modal-teammember");
              this.errors = {}
            }
            else {
              this.userAddingStepper++;
              this.errors = {}
            }
          }
          else {
            let error = {};
            nullKeys.forEach((x) => {
              error[x] = [this.$t('users.fieldRequired')];
            });
            throw error;
          }

        }
        catch (error) {
          this.setLoader(false)
          if (Array.isArray(error)) {
            await this.setNotification({
              msg: error[0],
              type: "error",
              color: "red",
            });
          }
          else if (typeof error === "object" && error.error) {
            await this.setNotification({
              msg: error.error,
              type: "error",
              color: "red",
            });
          }
          else if (typeof error === "object") {
            this.errors = error;
            // eslint-disable-next-line no-ex-assign
          }
          else {
            await this.setNotification({
              msg: error,
              type: "error",
              color: "red",
            })
          }
        }
      }
      else {
        delete this.newTeamMember.is_active;
        const user = {
          first_name: this.newTeamMember.first_name,
          last_name: this.newTeamMember.last_name,
          email:
            this.newTeamMember.email
        };
        let postData = {
          user,
          role: this.newTeamMember.role,
          phone: this.newTeamMember.phone ? !this.newTeamMember.phone.includes("+1") ? "+1 " + this.newTeamMember.phone : this.newTeamMember.phone : '',
          company_id: this.userCompany,
          tags: this.newTeamMember.tags
        };
        try {
          if (this.newTeamMember.phone) {
            if (!this.checkPhoneFormat(this.newTeamMember.phone)) {
              throw {
                phone: [this.$t('users.wrongFormat')],
              };
            }
          }
          if (this.newTeamMember.email) {
            if (!this.checkEmail(this.newTeamMember.email)) {
              throw {
                email: [this.$t('users.wrongFormat')],
              };
            }
          }
          const nullKeys = this.checkNullValues({
            first_name: this.newTeamMember.first_name,
            last_name: this.newTeamMember.last_name,
            role: this.newTeamMember.role,
            email: this.newTeamMember.email,
          });
          if (nullKeys.length === 0) {
            try {
              this.setLoader(true)
              const newMember = await this.addTeamMember({ ...postData, roles: [this.newTeamMember.role], role: "User" });
              if (newMember) {
                await this.getTeamMemberData();
                await this.sendInviteTeam(newMember.id, "user-invite");
                this.userAddingStepper = 0
                await this.setNotification({
                  msg: this.$t('users.userAdded', { name: `${newMember.user.first_name} ${newMember.user.last_name}` }),
                  type: "success",
                  color: "green",
                });
              }
              this.setLoader(false)
              this.$bvModal.hide("modal-teammember");
            } catch (e) {
              this.setLoader(false)
              await this.setNotification({
                msg: `${Object.keys(e?.user)[0]}: ${e?.user[Object.keys(e?.user)[0]]
                  }`,
                type: "error",
                color: "red",
              });
            }
          } else {
            let error = {};
            nullKeys.forEach((x) => {
              error[x] = [this.$t('users.fieldRequired')];
            });
            throw error;
          }
        } catch (error) {
          if (typeof error === "object") {
            this.errors = error;
            // eslint-disable-next-line no-ex-assign
          }
        }
      }
    },
    async getTeamMemberData() {
      try {
        this.isBusy = true
        let url = ""
        if (this.sortBy) {
          url += `sort_field=${this.sortBy}&sort_order=${this.sortDesc ? "desc" : "asc"}&`
        }
        else {
          url += `sort_field=name&sort_order=asc&`
        }
        url += `page=${this.currentPage}&page_size=${this.perPage}`
        const data = await this.getAllTeamMembers(url);
        if (data.total_entries) {
          this.rows = data.total_entries
          const start = this.currentPage === 1 ? 1 : (this.perPage * (this.currentPage - 1)) + 1
          const end = this.perPage * (this.currentPage - 1) + data.queryset_count
          this.positionText = this.$t('users.positionText', { start, end, total: data.total_entries })
        }
        else {
          this.rows = 0
          this.positionText = this.$t('users.emptyPosition')
        }
        const teamMemberData = [];
        this.allTeamMembers.map((member) => {
          const data = {
            name: `${member.user.first_name} ${member.user.last_name}`,
            username: member.user.username,
            first_name: member.user.first_name,
            last_name: member.user.last_name,
            role: member.roles[0],
            email: member.user.email ? member.user.email : "",
            phone: member.phone ? member.phone : "-",
            app_user: member.user.is_active ? "Active" : "Inactive",
            id: member.id,
            Image: member.profile_picture,
            dispatch_group1: member.dispatch_group1,
            dispatch_group2: member.dispatch_group2,
            tags: member.tags,
            last_login: member.user.last_login
          };
          teamMemberData.push(data);
        });
        this.items = teamMemberData;
        if (this.items.length === 0) this.emptyTable = true
        else this.emptyTable = false
        this.isBusy = false
      }
      catch (e) {
        this.isBusy = false
        console.log(e)
      }
    },
    getCountryName(id) {
      return this.allCountries.filter((item) => item.id === id)[0].name;
    },
  },
  watch: {
    perPage: {
      async handler() {
        await this.getTeamMemberData();
      },
      immediate: true,
    },
    currentPage: {
      async handler() {
        await this.getTeamMemberData();
      },
    },
    sortBy: {
      async handler() {
        await this.getTeamMemberData();
      },
    },
    sortDesc: {
      async handler() {
        await this.getTeamMemberData();
      },
    },
  },
  async mounted() {
    try {
      await this.getRoles()
      this.tags.map((item) => {
        this.allTags.push({
          id: item.id,
          label: item.add_tag,
        });
      });
    } catch (error) {
      if (error.status === 403) {
        await this.setNotification({
          msg: this.$t('users.noPermission'),
          type: "error",
          color: "red",
        });
      }
    }
  },
};
</script>